export const CONFIGS: any = {
  APP_VERSION: "1.0",

  APP_STORE_LINK:
    "https://apps.apple.com/us/app/%E4%BA%91%E9%9B%80%E5%AE%A2%E6%9C%8D/id1483441179?l=zh&ls=1",
  ANDROID_DOWNLOAD_LINK:
    "https://yunque-company-cdn.yunque360.com/YunQueKFAndroid-latest.apk",
};
